let openFeedbackModal: (() => void) | null = null;

export function registerFeedbackOpener(fn: (() => void) | null) {
  openFeedbackModal = fn;
}

export function requestOpenFeedback() {
  openFeedbackModal?.();
}
